import { Dialog } from "primereact/dialog";

import type { BalanceUiT } from "../domain/ui/balance.model";

import AccrualsTable from "./AccrualsTable";

type AccrualsDialogPropsT = {
  onHide: () => void;
  collaborator: BalanceUiT;
};

const AccrualsDialog = ({ onHide, collaborator }: AccrualsDialogPropsT) => {
  return (
    <Dialog
      visible
      header={
        <div className="flex flex-col gap-1">
          <span className="text-[1.25rem] font-semibold">Saldos</span>
        </div>
      }
      style={{ width: "90vw", maxWidth: "80rem", height: "35rem" }}
      onHide={onHide}
    >
      <div className="w-full h-full flex flex-col gap-2">
        <AccrualsTable collaboratorBalance={collaborator} />
      </div>
    </Dialog>
  );
};

export default AccrualsDialog;
